import { css } from 'styled-components';

export const gridPattern = css`
  margin: 0 auto;
  display: grid;
  justify-content: center;
  max-width: 425px;
  grid-template-columns: repeat(4, 1fr);
  gap: 0 12px;

  @media (min-width: 426px) {
    max-width: 768px;
    width: 100%;
    grid-template-columns: repeat(8, 1fr);
    gap: 0 12px;
  }

  @media (min-width: 768px) {
    max-width: 1168px;
    width: 100%;
    grid-template-columns: repeat(12, 1fr);
    gap: 0 20px;
  }

  & > div,
  > section {
    grid-column: 1 / 5;
    padding-inline: 24px;

    @media (min-width: 426px) {
      grid-column: 1 / 9;
    }

    @media (min-width: 768px) {
      grid-column: 1 / 13;
    }

    @media (min-width: 1365px) {
      padding-inline: 0;
    }
  }
`;
